import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/src/app/global-error.tsx");
